import React from "react";
var __jsx = React.createElement;
import { CDN_LINK } from "@globalConfig";
import { useTranslation } from "@i18n";
var CustomFileInput = function CustomFileInput(_ref) {
  var bankName = _ref.bankName,
    selectedFile = _ref.selectedFile,
    setSelectedFile = _ref.setSelectedFile,
    removeSelectedFile = _ref.removeSelectedFile;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "pt-4 pb-2 border-t border-[#d6dfe9]"
  }, /*#__PURE__*/React.createElement("label", {
    className: "text-xs leading-4 text-[#154f9c] font-bold mb-3 block"
  }, t("attach_photo_transfer", {
    ns: "web_common"
  })), selectedFile ? /*#__PURE__*/React.createElement("div", {
    className: "py-2 ps-[10px] pe-2 border border-[#154f9c] rounded flex justify-between items-center"
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/upload-file-blue.svg",
    alt: ""
  }), /*#__PURE__*/React.createElement("span", {
    className: "ms-auto me-[5px] text-xs leading-[18px] text-[#154f9c]"
  }, selectedFile.name), /*#__PURE__*/React.createElement("button", {
    className: "flex justify-center items-center w-4 h-4 border-none rounded-full cursor-pointer bg-transparent text-[10px] text-[#6c7a8d]",
    onClick: function onClick() {
      return removeSelectedFile(bankName);
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/x-icon.svg",
    alt: ""
  }))) : /*#__PURE__*/React.createElement("div", {
    className: "h-10 relative border border-dashed border-[#d6dfe9] rounded p-[11px] flex items-center"
  }, /*#__PURE__*/React.createElement("input", {
    type: "file",
    name: bankName,
    onChange: function onChange(e) {
      return setSelectedFile(bankName, e.target.files[0]);
    },
    className: "absolute w-full h-full opacity-0 cursor-pointer"
  }), /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/upload-file-black.svg",
    alt: ""
  }), /*#__PURE__*/React.createElement("span", {
    className: "text-xs leading-[18px] text-[#6c7a8d] ms-1.5 font-normal"
  }, t("upload_copy_transfer_document", {
    ns: "web_common"
  }))));
};
export default CustomFileInput;